// src/reducers/saleReducers.js

import {
  // SALES MANAGEMENT
  ADD_SALE_REQUEST, ADD_SALE_SUCCESS, ADD_SALE_FAIL, ADD_SALE_RESET,
  UPDATE_SALE_REQUEST, UPDATE_SALE_SUCCESS, UPDATE_SALE_FAIL,
  DELETE_SALE_REQUEST, DELETE_SALE_SUCCESS, DELETE_SALE_FAIL,
  GET_SALES_REQUEST, GET_SALES_SUCCESS, GET_SALES_FAIL,
  GET_SALE_DETAIL_REQUEST, GET_SALE_DETAIL_SUCCESS, GET_SALE_DETAIL_FAIL,
  IMPORT_SALES_CSV_REQUEST, IMPORT_SALES_CSV_SUCCESS, IMPORT_SALES_CSV_FAIL,
  GET_CUSTOMER_ORDERS_REQUEST, GET_CUSTOMER_ORDERS_SUCCESS, GET_CUSTOMER_ORDERS_FAIL,

    CREATE_SALE_WITH_CUSTOM_INVOICE_REQUEST, CREATE_SALE_WITH_CUSTOM_INVOICE_SUCCESS,
  CREATE_SALE_WITH_CUSTOM_INVOICE_FAIL, CREATE_SALE_WITH_CUSTOM_INVOICE_RESET,

  // INVOICES & BILLING
  GENERATE_INVOICE_REQUEST, GENERATE_INVOICE_SUCCESS, GENERATE_INVOICE_FAIL,
  GET_INVOICE_HISTORY_REQUEST, GET_INVOICE_HISTORY_SUCCESS, GET_INVOICE_HISTORY_FAIL,
  GET_PENDING_PAYMENTS_REQUEST, GET_PENDING_PAYMENTS_SUCCESS, GET_PENDING_PAYMENTS_FAIL,
  GET_PAYMENT_RECEIPTS_REQUEST, GET_PAYMENT_RECEIPTS_SUCCESS, GET_PAYMENT_RECEIPTS_FAIL,
  GET_RECURRING_INVOICES_REQUEST, GET_RECURRING_INVOICES_SUCCESS, GET_RECURRING_INVOICES_FAIL,

  // CUSTOMER MANAGEMENT
  GET_CUSTOMER_LIST_REQUEST, GET_CUSTOMER_LIST_SUCCESS, GET_CUSTOMER_LIST_FAIL,
  GET_CUSTOMER_PROFILES_REQUEST, GET_CUSTOMER_PROFILES_SUCCESS, GET_CUSTOMER_PROFILES_FAIL,

  // SALES ANALYTICS & REPORTS
  GET_SALES_DASHBOARD_REQUEST, GET_SALES_DASHBOARD_SUCCESS, GET_SALES_DASHBOARD_FAIL,
  GET_SALES_BY_PRODUCT_REQUEST, GET_SALES_BY_PRODUCT_SUCCESS, GET_SALES_BY_PRODUCT_FAIL,
  GET_SALES_GROWTH_TRENDS_REQUEST, GET_SALES_GROWTH_TRENDS_SUCCESS, GET_SALES_GROWTH_TRENDS_FAIL,

  // PAYMENT MANAGEMENT
  GET_PAYMENT_METHODS_REQUEST, GET_PAYMENT_METHODS_SUCCESS, GET_PAYMENT_METHODS_FAIL,
  GET_PARTIAL_PAYMENTS_REQUEST, GET_PARTIAL_PAYMENTS_SUCCESS, GET_PARTIAL_PAYMENTS_FAIL,
  GET_REFUND_PROCESSING_REQUEST, GET_REFUND_PROCESSING_SUCCESS, GET_REFUND_PROCESSING_FAIL,
  GET_PAYMENT_REMINDERS_REQUEST, GET_PAYMENT_REMINDERS_SUCCESS, GET_PAYMENT_REMINDERS_FAIL,

  // RETURNS & REFUNDS
  GET_RETURN_REQUESTS_REQUEST, GET_RETURN_REQUESTS_SUCCESS, GET_RETURN_REQUESTS_FAIL,
  GET_REFUND_STATUS_REQUEST, GET_REFUND_STATUS_SUCCESS, GET_REFUND_STATUS_FAIL,
  GET_DAMAGED_GOODS_RETURNS_REQUEST, GET_DAMAGED_GOODS_RETURNS_SUCCESS, GET_DAMAGED_GOODS_RETURNS_FAIL,
  GET_CUSTOMER_REFUND_APPROVALS_REQUEST, GET_CUSTOMER_REFUND_APPROVALS_SUCCESS, GET_CUSTOMER_REFUND_APPROVALS_FAIL,
  GET_SUPPLIER_RETURN_MANAGEMENT_REQUEST, GET_SUPPLIER_RETURN_MANAGEMENT_SUCCESS, GET_SUPPLIER_RETURN_MANAGEMENT_FAIL,
  GET_WARRANTY_BASED_RETURNS_REQUEST, GET_WARRANTY_BASED_RETURNS_SUCCESS, GET_WARRANTY_BASED_RETURNS_FAIL,
// NEW: Add Return/Refund
  ADD_RETURN_REFUND_REQUEST, ADD_RETURN_REFUND_SUCCESS, ADD_RETURN_REFUND_FAIL, ADD_RETURN_REFUND_RESET,

  // CLEAR ERRORS/MESSAGES
  CLEAR_SALE_ERRORS, CLEAR_SALE_MESSAGES
} from "../constants/saleConstants";

// --- Add Sale Reducer ---
export const saleAddReducer = (state = { sale: null }, action) => {
  switch (action.type) {
    case ADD_SALE_REQUEST:
      return { loading: true, error: null };
    case ADD_SALE_SUCCESS:
      return { loading: false, success: true, sale: action.payload };
    case ADD_SALE_FAIL:
      return { loading: false, error: action.payload, sale: null };
    case ADD_SALE_RESET:
      return { sale: null };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state, success: false };
    default:
      return state;
  }
};

// --- Create Sale With Custom Invoice Reducer ---
export const createSaleWithCustomInvoiceReducer = (state = { sale: null }, action) => {
  switch (action.type) {
    case CREATE_SALE_WITH_CUSTOM_INVOICE_REQUEST:
      return { loading: true, error: null };
    case CREATE_SALE_WITH_CUSTOM_INVOICE_SUCCESS:
      return { loading: false, success: true, sale: action.payload };
    case CREATE_SALE_WITH_CUSTOM_INVOICE_FAIL:
      return { loading: false, error: action.payload, sale: null };
    case CREATE_SALE_WITH_CUSTOM_INVOICE_RESET:
      return { sale: null };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state, success: false };
    default:
      return state;
  }
};

// --- Update Sale Reducer ---
export const saleUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_SALE_REQUEST:
      return { loading: true };
    case UPDATE_SALE_SUCCESS:
      return { loading: false, success: true, sale: action.payload };
    case UPDATE_SALE_FAIL:
      return { loading: false, error: action.payload };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state, success: false };
    default:
      return state;
  }
};

// --- Delete Sale Reducer ---
export const saleDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_SALE_REQUEST:
      return { loading: true };
    case DELETE_SALE_SUCCESS:
      return { loading: false, success: true };
    case DELETE_SALE_FAIL:
      return { loading: false, error: action.payload };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state, success: false };
    default:
      return state;
  }
};

// --- Get All Sales Reducer ---
export const salesListReducer = (state = { sales: [], loading: false, error: null }, action) => {
  switch (action.type) {
    case GET_SALES_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_SALES_SUCCESS:
      return { loading: false, sales: action.payload, error: null };
    case GET_SALES_FAIL:
      return { loading: false, error: action.payload, sales: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state }; // No "message" or "success" field here but included for symmetry
    default:
      return state;
  }
};

// --- Sale Detail Reducer ---
export const saleDetailReducer = (state = { sale: null }, action) => {
  switch (action.type) {
    case GET_SALE_DETAIL_REQUEST:
      return { loading: true, ...state };
    case GET_SALE_DETAIL_SUCCESS:
      return { loading: false, sale: action.payload };
    case GET_SALE_DETAIL_FAIL:
      return { loading: false, error: action.payload, sale: null };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

// --- Import Sales from CSV Reducer ---
export const salesImportReducer = (state = {}, action) => {
  switch (action.type) {
    case IMPORT_SALES_CSV_REQUEST:
      return { loading: true };
    case IMPORT_SALES_CSV_SUCCESS:
      return { loading: false, success: true };
    case IMPORT_SALES_CSV_FAIL:
      return { loading: false, error: action.payload };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state, success: false };
    default:
      return state;
  }
};

// --- Get Customer Orders Reducer ---
export const customerOrdersReducer = (state = { orders: [] }, action) => {
  switch (action.type) {
    case GET_CUSTOMER_ORDERS_REQUEST:
      return { loading: true, orders: [] };
    case GET_CUSTOMER_ORDERS_SUCCESS:
      return { loading: false, orders: action.payload };
    case GET_CUSTOMER_ORDERS_FAIL:
      return { loading: false, error: action.payload, orders: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

// --- Generate Invoice Reducer ---
export const invoiceGenerateReducer = (state = {}, action) => {
  switch (action.type) {
    case GENERATE_INVOICE_REQUEST:
      return { loading: true };
    case GENERATE_INVOICE_SUCCESS:
      return { loading: false, success: true, pdf: action.payload };
    case GENERATE_INVOICE_FAIL:
      return { loading: false, error: action.payload };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state, success: false };
    default:
      return state;
  }
};

// --- Invoice History Reducer ---
export const invoiceHistoryReducer = (state = { invoices: [] }, action) => {
  switch (action.type) {
    case GET_INVOICE_HISTORY_REQUEST:
      return { loading: true, invoices: [] };
    case GET_INVOICE_HISTORY_SUCCESS:
      return { loading: false, invoices: action.payload };
    case GET_INVOICE_HISTORY_FAIL:
      return { loading: false, error: action.payload, invoices: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

// --- Pending Payments Reducer ---
export const pendingPaymentsReducer = (state = { pendingPayments: [] }, action) => {
  switch (action.type) {
    case GET_PENDING_PAYMENTS_REQUEST:
      return { loading: true, pendingPayments: [] };
    case GET_PENDING_PAYMENTS_SUCCESS:
      return { loading: false, pendingPayments: action.payload };
    case GET_PENDING_PAYMENTS_FAIL:
      return { loading: false, error: action.payload, pendingPayments: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

// --- Payment Receipts Reducer ---
export const paymentReceiptsReducer = (state = { paymentReceipts: [] }, action) => {
  switch (action.type) {
    case GET_PAYMENT_RECEIPTS_REQUEST:
      return { loading: true, paymentReceipts: [] };
    case GET_PAYMENT_RECEIPTS_SUCCESS:
      return { loading: false, paymentReceipts: action.payload };
    case GET_PAYMENT_RECEIPTS_FAIL:
      return { loading: false, error: action.payload, paymentReceipts: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

// --- Recurring Invoices Reducer ---
export const recurringInvoicesReducer = (state = { recurringInvoices: [] }, action) => {
  switch (action.type) {
    case GET_RECURRING_INVOICES_REQUEST:
      return { loading: true, recurringInvoices: [] };
    case GET_RECURRING_INVOICES_SUCCESS:
      return { loading: false, recurringInvoices: action.payload };
    case GET_RECURRING_INVOICES_FAIL:
      return { loading: false, error: action.payload, recurringInvoices: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

// --- Customer List ---
export const customerListReducer = (
  state = { customers: [] },
  action
) => {
  switch (action.type) {
    case GET_CUSTOMER_LIST_REQUEST:
      return { loading: true, customers: [] };
    case GET_CUSTOMER_LIST_SUCCESS:
      return { loading: false, customers: action.payload };
    case GET_CUSTOMER_LIST_FAIL:
      return { loading: false, error: action.payload, customers: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return state;
    default:
      return state;
  }
};

// --- Customer Profiles ---
export const customerProfilesReducer = (
  state = { customers: [] },
  action
) => {
  switch (action.type) {
    case GET_CUSTOMER_PROFILES_REQUEST:
      return { loading: true, customers: [] };
    case GET_CUSTOMER_PROFILES_SUCCESS:
      return { loading: false, customers: action.payload };
    case GET_CUSTOMER_PROFILES_FAIL:
      return { loading: false, error: action.payload, customers: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return state;
    default:
      return state;
  }
};

// --- Sales Analytics Reducers ---
export const salesDashboardReducer = (state = { dashboard: {} }, action) => {
  switch (action.type) {
    case GET_SALES_DASHBOARD_REQUEST:
      return { loading: true, dashboard: {} };
    case GET_SALES_DASHBOARD_SUCCESS:
      return { loading: false, dashboard: action.payload };
    case GET_SALES_DASHBOARD_FAIL:
      return { loading: false, error: action.payload, dashboard: {} };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

export const salesByProductReducer = (state = { byProduct: [] }, action) => {
  switch (action.type) {
    case GET_SALES_BY_PRODUCT_REQUEST:
      return { loading: true, byProduct: [] };
    case GET_SALES_BY_PRODUCT_SUCCESS:
      return { loading: false, byProduct: action.payload };
    case GET_SALES_BY_PRODUCT_FAIL:
      return { loading: false, error: action.payload, byProduct: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

export const salesGrowthTrendsReducer = (state = { trends: [] }, action) => {
  switch (action.type) {
    case GET_SALES_GROWTH_TRENDS_REQUEST:
      return { loading: true, trends: [] };
    case GET_SALES_GROWTH_TRENDS_SUCCESS:
      return { loading: false, trends: action.payload };
    case GET_SALES_GROWTH_TRENDS_FAIL:
      return { loading: false, error: action.payload, trends: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

// --- Payment Management Reducers ---
export const paymentMethodsReducer = (state = { methods: [] }, action) => {
  switch (action.type) {
    case GET_PAYMENT_METHODS_REQUEST:
      return { loading: true, methods: [] };
    case GET_PAYMENT_METHODS_SUCCESS:
      return { loading: false, methods: action.payload };
    case GET_PAYMENT_METHODS_FAIL:
      return { loading: false, error: action.payload, methods: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

export const partialPaymentsReducer = (state = { partialPayments: [] }, action) => {
  switch (action.type) {
    case GET_PARTIAL_PAYMENTS_REQUEST:
      return { loading: true, partialPayments: [] };
    case GET_PARTIAL_PAYMENTS_SUCCESS:
      return { loading: false, partialPayments: action.payload };
    case GET_PARTIAL_PAYMENTS_FAIL:
      return { loading: false, error: action.payload, partialPayments: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

export const refundProcessingReducer = (state = { refunds: [] }, action) => {
  switch (action.type) {
    case GET_REFUND_PROCESSING_REQUEST:
      return { loading: true, refunds: [] };
    case GET_REFUND_PROCESSING_SUCCESS:
      return { loading: false, refunds: action.payload };
    case GET_REFUND_PROCESSING_FAIL:
      return { loading: false, error: action.payload, refunds: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

export const paymentRemindersReducer = (state = { reminders: [] }, action) => {
  switch (action.type) {
    case GET_PAYMENT_REMINDERS_REQUEST:
      return { loading: true, reminders: [] };
    case GET_PAYMENT_REMINDERS_SUCCESS:
      return { loading: false, reminders: action.payload };
    case GET_PAYMENT_REMINDERS_FAIL:
      return { loading: false, error: action.payload, reminders: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

// --- Returns & Refunds Reducers ---
export const returnRequestsReducer = (state = { returns: [] }, action) => {
  switch (action.type) {
    case GET_RETURN_REQUESTS_REQUEST:
      return { loading: true, returns: [] };
    case GET_RETURN_REQUESTS_SUCCESS:
      return { loading: false, returns: action.payload };
    case GET_RETURN_REQUESTS_FAIL:
      return { loading: false, error: action.payload, returns: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

export const refundStatusReducer = (state = { refundStatus: [] }, action) => {
  switch (action.type) {
    case GET_REFUND_STATUS_REQUEST:
      return { loading: true, refundStatus: [] };
    case GET_REFUND_STATUS_SUCCESS:
      return { loading: false, refundStatus: action.payload };
    case GET_REFUND_STATUS_FAIL:
      return { loading: false, error: action.payload, refundStatus: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

export const damagedGoodsReturnsReducer = (state = { damagedReturns: [] }, action) => {
  switch (action.type) {
    case GET_DAMAGED_GOODS_RETURNS_REQUEST:
      return { loading: true, damagedReturns: [] };
    case GET_DAMAGED_GOODS_RETURNS_SUCCESS:
      return { loading: false, damagedReturns: action.payload };
    case GET_DAMAGED_GOODS_RETURNS_FAIL:
      return { loading: false, error: action.payload, damagedReturns: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

export const customerRefundApprovalsReducer = (state = { approvals: [] }, action) => {
  switch (action.type) {
    case GET_CUSTOMER_REFUND_APPROVALS_REQUEST:
      return { loading: true, approvals: [] };
    case GET_CUSTOMER_REFUND_APPROVALS_SUCCESS:
      return { loading: false, approvals: action.payload };
    case GET_CUSTOMER_REFUND_APPROVALS_FAIL:
      return { loading: false, error: action.payload, approvals: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

export const supplierReturnManagementReducer = (state = { supplierReturns: [] }, action) => {
  switch (action.type) {
    case GET_SUPPLIER_RETURN_MANAGEMENT_REQUEST:
      return { loading: true, supplierReturns: [] };
    case GET_SUPPLIER_RETURN_MANAGEMENT_SUCCESS:
      return { loading: false, supplierReturns: action.payload };
    case GET_SUPPLIER_RETURN_MANAGEMENT_FAIL:
      return { loading: false, error: action.payload, supplierReturns: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

export const warrantyBasedReturnsReducer = (state = { warrantyReturns: [] }, action) => {
  switch (action.type) {
    case GET_WARRANTY_BASED_RETURNS_REQUEST:
      return { loading: true, warrantyReturns: [] };
    case GET_WARRANTY_BASED_RETURNS_SUCCESS:
      return { loading: false, warrantyReturns: action.payload };
    case GET_WARRANTY_BASED_RETURNS_FAIL:
      return { loading: false, error: action.payload, warrantyReturns: [] };
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state };
    default:
      return state;
  }
};

export const returnRefundAddsaleReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_RETURN_REFUND_REQUEST:
      return { loading: true };
    case ADD_RETURN_REFUND_SUCCESS:
      return { loading: false, success: true, returnRefund: action.payload };
    case ADD_RETURN_REFUND_FAIL:
      return { loading: false, error: action.payload };
    case ADD_RETURN_REFUND_RESET:
      return {};
    case CLEAR_SALE_ERRORS:
      return { ...state, error: null };
    case CLEAR_SALE_MESSAGES:
      return { ...state, success: false };
    default:
      return state;
  }
};